/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import memberClient from '@api-member/mbp';
import restClient from '../cart-service-apis/restClient';

const RESOURCE_ROOT_ADDRESSSERVICE = 'addressbook';
const RESOURCE_VERSION_ADDRESS = '/v2';
const RESOURCE_PAGE_ADDRESSSERVICE = '/contacts';
const RESOURCE_PAGE_ACTION = '/entries';

const removeAddressBookV2 = ({
    wcEnv, jwtToken, contactId, addressBookEntryId,
}) => {
    const envObj = wcEnv || {};

    envObj.rootUri = `/${RESOURCE_ROOT_ADDRESSSERVICE}${RESOURCE_VERSION_ADDRESS}`;

    const resourcePage = `${RESOURCE_PAGE_ADDRESSSERVICE}/${contactId}${RESOURCE_PAGE_ACTION}/${addressBookEntryId}`;

    return restClient.deleteRequest(wcEnv, resourcePage, jwtToken)
        .then((response) => response);
};

export default removeAddressBookV2;
